export default function roundNumber(number: number, decimals: number): number {
  const factor = 10 ** decimals;
  return Math.round(number * factor) / factor;
}
